export default __webpack_public_path__ + "static/media/Public-Notice-for-Web-English-21102020.d4280336.jpg";